import axios from 'axios';
import dayjs from 'dayjs';
import jwtDecode from 'jwt-decode';
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { APP_LANGS } from 'state/app';
import { signIn, signOut, tokenToUser } from 'state/auth';
import eng from 'translations/eng.json';
import ger from 'translations/ger.json';
import pol from 'translations/pol.json';
import ukr from 'translations/ukr.json';

import Root from './pages/Root';

axios.defaults.baseURL = 'https://info-cms.konsport.com/wp-json';

const getMessages = (lang) => {
   switch (lang) {
      default:
      case APP_LANGS.POL:
         return pol;
      case APP_LANGS.ENG:
         return eng;
      case APP_LANGS.UKR:
         return ukr;
      case APP_LANGS.GER:
         return ger;
   }
};

const now = new Date();

const App = () => {
   const dispatch = useDispatch();
   const { lang, initialized } = useSelector((state) => state.app);

   const token = localStorage.getItem('token');
   const t = token ? jwtDecode(token) : null;
   const diff = t?.exp ? dayjs.unix(t.exp).diff(now, 'ms') : 0;

   useEffect(() => {
      if (diff > 0) {
         axios.defaults.headers['Authorization'] = `Bearer ${token}`;

         const u = tokenToUser(t);
         dispatch(signIn(u));
      } else {
         dispatch(signOut());
      }
   }, [dispatch, token, t, diff]);

   useEffect(() => {
      dispatch({ type: 'INITIALIZED', initialized: true });
   }, [dispatch]);

   return (
      <IntlProvider messages={getMessages(lang)} locale={lang} defaultLocale={APP_LANGS.POL}>
         {initialized ? <Root /> : <></>}
      </IntlProvider>
   );
};

export default App;
